import {LandingHeader} from "./components/landing-header";
import {WelcomeBanner} from "./components/welcome-banner";
import {ProblemStatement} from "./components/problem-statement";
import {HowItWorks} from "./components/how-it-works";
import {Benefits} from "./components/benefits";
import {TechnicalAndDemo} from "./components/technical-and-demo";
import {Partners} from "./components/partners";
import {LandingFooter} from "./components/landing-footer";


export const LandingPage = () => {

  return (
    <>
      <LandingHeader />
      <WelcomeBanner />
      <ProblemStatement />
      <HowItWorks />
      <Benefits />
      <TechnicalAndDemo />
      <Partners />
      <LandingFooter />
    </>
  )
}